// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.D3Wrapper.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { isUndefined } from 'lodash/fp';
import D3RenderingServices from './Izenda.D3RenderingServices';

const MIN_CONTAINER_SIZE = 15;

const getCurrentGlobal = () => (typeof window !== 'undefined' ? window : this);
let d3Cached = {};

function backUpD3() {
  const global = getCurrentGlobal();
  let temp = undefined;
  if (!isUndefined(global.d3)) {
    temp = global.d3;
    global.d3 = undefined;
  }
  return temp;
}

function restoreD3(backUp) {
  const global = getCurrentGlobal();
  global.d3 = backUp;
}

function getIzD3() {
  if (d3Cached.d3) {
    return d3Cached.d3;
  }
  const backup = backUpD3();

  global.d3 = require('d3');
  d3Cached.d3 = global.d3;

  restoreD3(backup);
  return d3Cached.d3;
}

function destroyD3() {
  d3Cached.d3 = null;
}

export const d3 = getIzD3();

export default class D3Wrapper {
  /**
   * Constructor
   * @param {DOMElement} chartContainer
   * @param {Object} options
   * @param {Function} onCompleted
   */
  constructor(chartContainer, options, onCompleted) {
    ensure(!isUndefined(chartContainer), 'Container must be provided.');

    this.container = chartContainer;
    const { offsetWidth: containerWidth, offsetHeight: containerHeight } = this.container;

    // Clear old content
    d3.select(this.container)
      .selectAll('*')
      .remove();

    // Not enough space
    if (Math.min(containerWidth, containerHeight) <= MIN_CONTAINER_SIZE) {
      this.container.innerHTML = '<i class="icon-chart-bar">';
      onCompleted();
    } else {
      const d3Container = d3
        .select(this.container)
        .append('div')
        .classed('d3-container', true);
      this.svg = d3Container.append('svg');
      this.renderingServices = new D3RenderingServices(this.svg, d3Container.node());
      this.renderingServices
        .draw(options)
        .then(onCompleted)
        .then(() => (this.hasRendered = true));
    }
  }

  /**
   * Clean up
   */
  destroy() {
    destroyD3();
    this.svg.remove();
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/charting/d3/Izenda.D3Wrapper.js